import { styled } from "@mui/material";
import { FaWhatsapp } from "react-icons/fa";

export type FloatingWhatsAppButtonProps = {
  phoneNumber?: string | null;
  defaultMessage?: string;
};

const DEFAULT_MESSAGE = "Hola, me gustaria recibir mas informacion.";

const sanitizePhoneNumber = (value?: string | null) => {
  if (!value) return "";
  return value.replace(/[^\d]/g, "");
};

const FloatingWhatsAppButton = ({
  phoneNumber,
  defaultMessage,
}: FloatingWhatsAppButtonProps) => {
  const sanitizedPhone = sanitizePhoneNumber(phoneNumber);

  if (!sanitizedPhone) {
    return null;
  }

  const encodedMessage = encodeURIComponent(
    defaultMessage?.trim().length ? defaultMessage : DEFAULT_MESSAGE
  );

  const whatsappUrl = `https://wa.me/${sanitizedPhone}?text=`;

  return (
    <FloatingLink
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir conversación de WhatsApp"
    >
      <FaWhatsapp size={26} />
    </FloatingLink>
  );
};

const FloatingLink = styled("a")(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  width: 56,
  height: 56,
  borderRadius: "50%",
  backgroundColor: "#25D366",
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  boxShadow: theme.shadows[8],
  zIndex: 1250,
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  willChange: "transform",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: theme.shadows[10],
  },
  "&:focus-visible": {
    outline: `3px solid ${theme.palette.common?.white ?? "#fff"}`,
    outlineOffset: 2,
  },
  "@media (max-width:600px)": {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

export default FloatingWhatsAppButton;
